import { render, staticRenderFns } from "./latestInventory.vue?vue&type=template&id=60a1fbe8&scoped=true&"
import script from "./latestInventory.vue?vue&type=script&lang=js&"
export * from "./latestInventory.vue?vue&type=script&lang=js&"
import style0 from "./latestInventory.vue?vue&type=style&index=0&id=60a1fbe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a1fbe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a1fbe8')) {
      api.createRecord('60a1fbe8', component.options)
    } else {
      api.reload('60a1fbe8', component.options)
    }
    module.hot.accept("./latestInventory.vue?vue&type=template&id=60a1fbe8&scoped=true&", function () {
      api.rerender('60a1fbe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/latestInventory.vue"
export default component.exports